<template>
	<div
		class="board"
		:class="{ bordered }"
	>
		<div class="board-inner">
			<div
				:key="y"
				class="board-row d-flex"
				v-for="y in rows"
			>
				<BoardCell
					:cols="cols"
					:key="x"
					:rows="rows"
					:x="x-1"
					:y="rows-y"
					v-for="x in cols"
				/>
			</div>

			<Stone
				:data-gpv="JSON.stringify(s)"
				:gpv="s"
				:key="[i, JSON.stringify(s)].join(';')"
				:style="stoneStyle(s)"
				v-for="(s,i) in stones"
			/>
		</div>
	</div>
</template>

<script>
import HHEvents from "../logic/events";

export default {
	props: ["bordered", "cols", "rows", "stones"],
	methods: {
		stoneStyle(gpv) {
			const x = gpv[0];
			const y = gpv[1];
			const left = `calc(${x} * 50% - ${x}px)`;
			const top = `calc(${y + 2} * -50% + ${y}px)`;
			return { transform: `translate(${left}, ${top})` };
		},
	},
};
</script>

<style lang="scss">
.board {
	background-image: url("../assets/wood_pattern.png");
	border-radius: 6px;
	box-shadow: 1px 1px 2px 1px rgba(0, 0, 0, 0.75);
	padding: 0.5rem;

	.board-inner {
		position: relative;

		.stone {
			position: absolute;
		}
	}
}
</style>
